const X_SERIES = 'X_SERIES'
const NEXT_GEN = 'NEXT_GEN'

const objects = {
    [X_SERIES]: {
        type: X_SERIES,
        label: 'X Series', // TODO: verify label, serial # format
        backgroundColor: '#55629F',
        textColor: '#CED7F9',
    },
    [NEXT_GEN]: {
        type: NEXT_GEN,
        label: 'NextGen', // TODO: verify label, serial # format
        backgroundColor: '#BDC3DB',
        textColor: '#505160',
    },
}

export default Object.freeze(objects)

export const byValue = (value) => {
    return objects[value.toUpperCase()]
}
